import React, { useState, useEffect, useRef } from 'react';
import { generatePyramid } from './numberPyramidLogic';
import html2canvas from 'html2canvas'; // ضروري يكون مستورد

const NumberPyramidBoard = ({ onAddToBook, seed = null }) => {
  const [gameData, setGameData] = useState(null);
  const [currentSeed, setCurrentSeed] = useState(seed || Date.now().toString());
  const [showSolution, setShowSolution] = useState(false);
  const printRef = useRef(null);

  const createGame = (newSeed = null) => {
    const s = newSeed || currentSeed;
    if (newSeed) setCurrentSeed(newSeed);
    const data = generatePyramid(4, 'medium', s);
    setGameData(data);
    setShowSolution(false);
  };

  useEffect(() => { createGame(); }, [seed]);

  const handleNewGame = () => {
    const newS = Date.now().toString();
    createGame(newS);
  };

  // ✅✅✅ التصحيح هنا: استعمال html2canvas
  const handleAddToBook = () => {
    if (printRef.current) {
        const wasShowing = showSolution;
        setShowSolution(false);
        
        setTimeout(() => {
            html2canvas(printRef.current).then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                onAddToBook('NumberPyramid', imgData, { seed: currentSeed });
                
                if(wasShowing) setShowSolution(true);
            });
        }, 100);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
      <h2 style={{ color: '#2d3436' }}>Number Pyramid 🔺</h2>
      
      {!seed && (
        <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
          <button onClick={handleNewGame} style={{ background: '#6c5ce7', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer'}}>🔄 New</button>
          <button onClick={() => setShowSolution(!showSolution)} style={{ background: showSolution?'#e17055':'#00b894', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer'}}>
             {showSolution ? 'Hide' : 'Solution'}
          </button>
          <button onClick={handleAddToBook} style={{ background: '#e67e22', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer'}}>📖 Add</button>
        </div>
      )}

      <div ref={printRef} style={{ padding: '50px', background: 'white', display:'flex', flexDirection:'column', alignItems:'center', gap:'5px', border: seed?'none':'1px solid #ddd' }}>
        {gameData && gameData.puzzle.map((row, rowIndex) => (
          <div key={rowIndex} style={{ display: 'flex', gap: '5px' }}>
            {row.map((val, colIndex) => {
              const solutionVal = gameData.solution[rowIndex][colIndex];
              const displayVal = val !== null ? val : (showSolution ? solutionVal : '');
              
              return (
                <div key={colIndex} style={{
                  width: '60px', height: '40px', 
                  border: '2px solid #2d3436', 
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  fontWeight: 'bold', fontSize: '18px',
                  background: val === null && showSolution ? '#ffeaa7' : 'white',
                  color: val === null && showSolution ? '#d63031' : 'black'
                }}>
                  {displayVal}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};
export default NumberPyramidBoard;